<template>
    <div>
        <div class="blocchetto-titolo">
                        <span>
                            <img src="/img/be/ico-cliente.png">Dati cliente
                        </span>
        </div>
        <div class="blocchetto-selezioni">
            <div class="col-12">
                <div class="form-group">
                    <input type="text" placeholder="Nome *" class="form-control" @input="this.onNameChange"
                           :value="this.form.name">
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <input type="text" placeholder="Cognome *" class="form-control" @input="this.onSurnameChange"
                           :value="this.form.surname">
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <input type="text" placeholder="Telefono *" class="form-control" @input="this.onPhoneChange"
                           :value="this.form.phone">
                </div>
            </div>
            <inc-privacy-checkboxes :privacy-checkboxes="this.privacyCheckboxes"
                                    @onPrivacyChange="this.onPrivacyChange"/>
        </div>
    </div>
</template>

<script>
import IncPrivacyCheckboxes from "../../partials/IncPrivacyCheckboxes";

export default {
    name: "IncUserData",
    components: {IncPrivacyCheckboxes},
    props: ['privacyCheckboxes'],
    data() {
        return {
            form: {
                name: '',
                surname: '',
                phone: '',
                privacy: null
            }
        }
    },
    methods: {
        onNameChange: function (e) {
            this.form.name = e.target.value;
            this.$emit('onUserDataChange', this.form);
        },
        onSurnameChange: function (e) {
            this.form.surname = e.target.value;
            this.$emit('onUserDataChange', this.form);
        },
        onPhoneChange: function (e) {
            this.form.phone = e.target.value;
            this.$emit('onUserDataChange', this.form);
        },
        onPrivacyChange: function (privacy) {
            this.form.privacy = privacy;
            this.$emit('onUserDataChange', this.form);
        }
    }
}
</script>
